import React, { useEffect, useState } from 'react';
import SockJsClient from 'react-stomp';
import InteractiveQuizRoom from './InteractiveQuizRoom';
import { selectCurrentQuestionIdRoomByUuid,
    selectUsersRoomByUuid,
    selectHostIdRoomByUuid } from 'app/redux/selectors/InteractiveQuiz/interactiveQuizRoom.selector';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addParticipant, removeParticipant, updateRoom } from 'app/redux/actions/InteractiveQuiz/interactiveQuizRoom.actions';
import {
    postRoomExistsApi,
    postUserJoinedInteractiveQuizRoomApi,
    postUserLeftInteractiveQuizRoomApi } from 'app/api/interactiveQuizApi';
import AuthenticationContainer from 'app/login/containers/AuthenticationContainer';
import { WebSocketActionsEnum } from 'app/utils/WebsocketActionsEnum';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import { selectSerieHistoryUpdate } from 'app/redux/selectors/Question/history.selector';
import { patchPendingSerieIsDoneApi } from 'app/api/historyApi';


export function InteractiveQuiz(props) {
    const uuidFromUrl = props.match.params.uuid;

    const dispatch = useDispatch();
    const currentUserId = Number(AuthenticationContainer.getCurrentUserId());
    const currentQuestionId = useSelector(selectCurrentQuestionIdRoomByUuid(uuidFromUrl));
    const users = useSelector(selectUsersRoomByUuid(uuidFromUrl));
    const hostId = Number(useSelector(selectHostIdRoomByUuid(uuidFromUrl)));
    const serieHistoryUpdate = useSelector(selectSerieHistoryUpdate);

    const [shouldRedirect, setShouldRedirect] = useState(false);

    useEffect(() => {
        let timeout = 0;
        if(!hostId) {
            timeout = setTimeout(() => {
                setShouldRedirect(true);
            }, 5000);
        }
        return () => clearTimeout(timeout);
    }, [hostId]);

    if(shouldRedirect) {
        return <Redirect to="/skills" />;
    }

    const interactiveQuizClassNames = classNames({
        'interactive-quiz-loader-container': !hostId,
        'interactive-quiz': hostId
    });

    return (
        <div data-testid="interactive-quiz" className={interactiveQuizClassNames}>
            <SockJsClient url={`${process.env.REACT_APP_BACK_END}websocket`}
                topics={[`/quiz/${uuidFromUrl}`, `/quiz/${uuidFromUrl}/userId/${currentUserId}`]}
                onConnect={() => {
                    postUserJoinedInteractiveQuizRoomApi(currentUserId, uuidFromUrl);
                }}
                onDisconnect={() => {
                    if(hostId !== currentUserId) {
                        postUserLeftInteractiveQuizRoomApi(currentUserId, uuidFromUrl);
                    }
                }}
                onMessage={(msg) => {
                    const { action, id, imageUrl, firstName, lastName, newLeader } = msg;
                    switch (action) {
                        case WebSocketActionsEnum.ADD: {
                            dispatch(addParticipant({
                                uuid: uuidFromUrl,
                                id,
                                imageUrl,
                                firstName,
                                lastName
                            }));
                            break;
                        }
                        case WebSocketActionsEnum.REMOVE: {
                            dispatch(removeParticipant({
                                uuid: uuidFromUrl,
                                id
                            }));
                            break;
                        }
                        case WebSocketActionsEnum.QUIZ_ENDED: {
                            patchPendingSerieIsDoneApi(serieHistoryUpdate.id, currentUserId);
                            break;
                        }
                        case WebSocketActionsEnum.CHECK: {
                            if(hostId !== -1 && hostId === currentUserId) {
                                postRoomExistsApi(uuidFromUrl, users.flatMap((user) => user.id), currentQuestionId);
                            }
                            break;
                        }
                        case WebSocketActionsEnum.NEW_LEADER:
                            const newHostId = newLeader;
                            dispatch(updateRoom(uuidFromUrl, {
                                hostId: newHostId,
                                shouldContinueQuizWithNewLeader: true
                            }));
                            break;
                        default:
                            break;
                    }
                }}
            />
            { hostId &&
                <InteractiveQuizRoom
                    uuid={uuidFromUrl}
                    users={users}
                    currentQuestionId={currentQuestionId}
                    hostId={hostId}
                />
            }

            { !hostId && <CircularProgress style={{ width: 50, height: 50 }}/> }
        </div>
    );
}

InteractiveQuiz.propTypes = {
    match: PropTypes.object
};

export default withRouter(InteractiveQuiz);
